<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

import NavLink from '../NavLink/NavLink.vue';

interface Props {
  to?: RouteLocationRaw;
  href?: string;
  isDisabled?: boolean;
}

defineProps<Props>();
</script>

<template>
  <NavLink class="secondary-nav-item" :to="to" :href="href" :isDisabled="isDisabled">
    <slot />
  </NavLink>
</template>

<style lang="scss">
@use './SecondaryNavItem.scss';
</style>
